import React, { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import AuthService from "../../services/Auth.service";
import { useHistory} from "react-router-dom";
import { checkPermission } from "../../utilities/hasPermission";
import "./Login.css";

export default function Login() {
  const history = useHistory();
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown((prev) => !prev);
  };

  // Validation schema
  const formSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const validationOpt = {
    resolver: yupResolver(formSchema),
    defaultValues: { rememberMe: false },
  };

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setError,
    reset,
  } = useForm(validationOpt);


  const onSubmit = async (formData) => {
    try {
      const response = await AuthService.login({
        email: formData.email,
        password: formData.password,
      });

      if (response.status === 200) {
        localStorage.setItem("user", JSON.stringify(response.data));
        const redirectPath = checkPermission.getDefaultAuthorizedPath();
        history.push(redirectPath);
      } else {
        setError("apiError", { message: "Unexpected response from server" });
      }
    } catch (error) {
        setError("apiError", { message: error.response.data.detail });
    }
  };

  var currentYear = new Date().getFullYear();

  return (
    <React.Fragment>
      <div className="warrper">
        <div className="login-box">
          <div className="login-container-inner">
            <div className="login-detail">
              <div className="left-box">
                <img src="/assets/images/login-banner.png" alt="login-banner" />
              </div>

              <div className="right-box">
                <div className="right-box-detail">
                  <img src="/assets/images/logo.svg" alt="logo" />

                  <form onSubmit={handleSubmit(onSubmit)} className="login-form">
                    {/* Email Field */}
                    <Controller
                      control={control}
                      name="email"
                      render={({ field }) => (
                        <div className="login-input-group">
                          <input
                            type="text"
                            className={`login-input-field ${errors.email ? "is-invalid" : ""}`}
                            placeholder=" "
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            value={field.value || ""}
                            ref={field.ref}
                            autoComplete="email"
                          />
                          <label className="login-input-label">Enter Your Email</label>
                          {errors.email && (
                            <div className="login-error-message">{errors.email.message}</div>
                          )}
                        </div>
                      )}
                    />

                    {/* Password Field */}
                    <div style={{ position: "relative" }}>
                      <Controller
                        control={control}
                        name="password"
                        render={({ field }) => (
                          <div className="login-input-group">
                            <input
                              type={passwordShown ? "text" : "password"}
                              className={`login-input-field ${errors.password ? "is-invalid" : ""}`}
                              placeholder=" "
                              onChange={field.onChange}
                              onBlur={field.onBlur}
                              value={field.value || ""}
                              ref={field.ref}
                              autoComplete="current-password"
                            />
                            <label className="login-input-label">Enter Password</label>
                            {errors.password && (
                              <div className="login-error-message">{errors.password.message}</div>
                            )}
                          </div>
                        )}
                      />
                      <button
                        type="button"
                        onClick={togglePasswordVisiblity}
                        style={{
                          position: "absolute",
                          right: "0px",
                          top: "23px",
                          transform: "translateY(-50%)",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          color: "#64748b",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: 0,
                          zIndex: 10,
                        }}
                        aria-label={passwordShown ? "Hide password" : "Show password"}
                      >
                        {passwordShown ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </div>

                    {/* API Error */}
                    {errors.apiError && (
                      <div className="alert alert-danger mt-3 mb-0">
                        {errors.apiError?.message}
                      </div>
                    )}

                    {/* Login Button */}
                    <div className="button-box">
                      <button
                        disabled={isSubmitting}
                        className="btn login-btn red-btn responshiv"
                      >
                        Login
                      </button>
                    </div>
                  </form>

                  {/* Footer */}
                  <div className="copy-rightbox">
                    <p>Copyright ValuEnable ©{currentYear} . All Rights Reserved</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
